import type { PatientOverviewTabOption } from "$routes/_lib/patient-overview-tab-option";
import { linkToPatient } from "$routes/patient/links";
import { stringify } from "qs";

const appendSearch = (params: Record<string, string>) => {
  return stringify(params, { addQueryPrefix: true });
};

export function linkToPatientDetails(
  opts: {
    patientUuid?: string;
    invoiceId?: string;
    selectedTab?: PatientOverviewTabOption;
  } = {},
) {
  const search = {
    ...opts,
  };

  return `${linkToPatient()}/details${appendSearch(search)}`;
}
